var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-overlay',{attrs:{"show":_vm.showOverlay,"rounded":"sm","opacity":0.5}},[_c('div',{staticClass:"container-scroller"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }